import { CANDIDATE_TOKEN_STORAGE_KEY, HR_SESSION_STORAGE_KEY } from '../constants';
import type { CandidateSession } from '@/types/careers';

// The candidate session lives apart from the HR session (auth-storage), so being signed in
// as a candidate never signs anyone into the HR app, and vice versa.

export function readCandidateSession(): CandidateSession | null {
  try {
    const raw = localStorage.getItem(CANDIDATE_TOKEN_STORAGE_KEY);
    if (!raw) return null;
    const session = JSON.parse(raw) as CandidateSession;
    if (!session?.token || new Date(session.expiresAt).getTime() <= Date.now()) {
      localStorage.removeItem(CANDIDATE_TOKEN_STORAGE_KEY);
      return null;
    }
    return session;
  } catch {
    return null;
  }
}

export function saveCandidateSession(session: CandidateSession): void {
  try {
    localStorage.setItem(CANDIDATE_TOKEN_STORAGE_KEY, JSON.stringify(session));
  } catch {
    // Private mode / blocked storage: the session simply lasts for this page only.
  }
}

export function clearCandidateSession(): void {
  try {
    localStorage.removeItem(CANDIDATE_TOKEN_STORAGE_KEY);
  } catch {
    // Nothing stored.
  }
}

/** The Peoply (HR app) session token, when one is stored and not expired; only read, never changed. */
export function readHrToken(): string | null {
  try {
    const stored = JSON.parse(localStorage.getItem(HR_SESSION_STORAGE_KEY) || 'null');
    const token: unknown = stored?.state?.token;
    if (typeof token !== 'string' || !token) return null;
    const payload = JSON.parse(atob(token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/')));
    return typeof payload?.exp === 'number' && payload.exp * 1000 > Date.now() ? token : null;
  } catch {
    return null;
  }
}
